export default __webpack_public_path__ + "static/media/2024_calendar_horz.09e0ae67.png";